export interface TenantShareSetting {
  id: string | null;
  tenantId: string;
  eventTypeId: number | null;
  eventTypeName: string | null;
  eventSubTypeId: number | null;
  eventSubTypeName: string | null;
  shareText: string;
  isDefault: boolean;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface TenantShareSettingUpsertPayload {
  eventTypeId: number | null;
  eventSubTypeId: number | null;
  shareText: string;
}

export const SHARE_TEXT_MAX_LENGTH = 500;

/** "General" cuando ambos niveles son null, o "Tipo / Sub-tipo" según lo que esté seteado. */
export const formatShareSettingScopeLabel = (
  setting: Pick<TenantShareSetting, "eventTypeId" | "eventTypeName" | "eventSubTypeId" | "eventSubTypeName">
): string => {
  if (setting.eventTypeId == null) return "General";

  const typeName = setting.eventTypeName ?? `Tipo ${setting.eventTypeId}`;
  if (setting.eventSubTypeId == null) return typeName;

  const subTypeName = setting.eventSubTypeName ?? `Subtipo ${setting.eventSubTypeId}`;
  return `${typeName} / ${subTypeName}`;
};

/** true si dos settings apuntan al mismo tier (tenantId, eventTypeId, eventSubTypeId). */
export const isSameShareSettingScope = (
  a: Pick<TenantShareSetting, "eventTypeId" | "eventSubTypeId">,
  b: Pick<TenantShareSetting, "eventTypeId" | "eventSubTypeId">
): boolean => a.eventTypeId === b.eventTypeId && a.eventSubTypeId === b.eventSubTypeId;
